import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TitleBlock = makeShortcode("TitleBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TitleBlock slots="heading" theme="lightest" className="ms-zigzag-cont-title" mdxType="TitleBlock" />
    <h2 {...{
      "id": "uplevel-your-document-workflows-easily-with-adobe-acrobat-services-and-adobe-acrobat-sign-on-microsoft-power-platform"
    }}>{`Uplevel your document workflows easily with Adobe Acrobat Services and Adobe Acrobat Sign on Microsoft Power Platform.`}</h2>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      